module.exports = __webpack_public_path__ + "img/android.2fdd732b.svg";